import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Footer } from '@/core/components';
import { Header } from '@/core/components/Header';
import { useDocumentTitle } from '@/core/hooks';
import { baseTheme } from '@/core/theme';

export function LPPage() {
  // デフォルトタイトルに戻す
  useDocumentTitle();

  return (
    <ThemeProvider theme={baseTheme}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header logo="/logo.png" title="RunPort NFT" useBrandGradient />

        <Container
          component="main"
          maxWidth="sm"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            py: 8,
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(135deg, #FF385C 0%, #D12D8C 50%, #6A2BFF 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            RunPort NFT
          </Typography>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            マラソン完走証をNFTで。
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 6, maxWidth: 400 }}>
            あなたの完走記録をブロックチェーンに刻み、永遠に残るデジタル完走証として受け取れます。
          </Typography>
        </Container>

        <Footer useBrandGradient />
      </Box>
    </ThemeProvider>
  );
}
